import React, { memo } from 'react';
import { AlertTriangle } from 'lucide-react';

import styles from './styles/WarningBox.module.css';

const WarningBox = ({ children, className = '' }) => {
    return (
        <div className={`${styles.warningBox} ${className}`}>
            <AlertTriangle size={16} />
            {typeof children === 'string' ? <p>{children}</p> : children}
        </div>
    );
};

export default memo(WarningBox);
